module.exports = __webpack_public_path__ + "ionicons.28df6ee7b407fd8a14b4.svg";


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/assets/fonts/ionicons.svg?v=2.0.1
// module id = ../../../../../src/assets/fonts/ionicons.svg?v=2.0.1
// module chunks = styles